import {
  ME,
  LOGOUT,
  GET_ACCESS_CODE,
  UPDATE_ACCOUNT_PIN,
  UPDATE_USERNAME
} from 'shared/actions/types';

import produce from 'immer';

const initialState = {
  user: null,
  access_code: '',
  loggedIn: false
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ME:
      return produce(state, draft => {
        draft.user = action.payload;
        draft.loggedIn = true;
      });

    case LOGOUT:
      return produce(state, draft => {
        draft.user = null;
        draft.loggedIn = false;
      });

    case GET_ACCESS_CODE:
      return produce(state, draft => {
        draft.access_code = action.payload;
      });

    case UPDATE_USERNAME:
      return produce(state, draft => {
        draft.user.name = action.payload;
      });

    case UPDATE_ACCOUNT_PIN:
      return produce(state, draft => {
        draft.user.account.pin = action.payload;
      });

    default:
      return state;
  }
}
